import propTypes from 'prop-types';
import _ from 'lodash';
import {
  parse,
  getTelemetry,
  getProperties,
  getCommands
} from '../../../../utils/dtdl';
import { parseContentId } from '../utils/model';


export const mapBindingContents = (dtdlTargetModels, bindingDescription) => {
  const contents = bindingDescription.contentBindingDescriptions;
  // const commandContents = _.map(contents, c => ({ ...c, contentId: c.sources[0].contentId, sources: [{ inputName: 'name', contentId: c.contentId }] }));
  const dtdlModel = parse(dtdlTargetModels[0], dtdlTargetModels);
  const telemetry = getTelemetry({ dtdlModel });
  const properties = getProperties({ dtdlModel });
  const commands = getCommands({ dtdlModel });

  const tb = filterBindings(telemetry, contents);
  const pb = filterBindings(properties, contents);
  const cb = filterBindings(commands, contents);

  return { tb, pb, cb, telemetry, properties, commands };
};

export const mapModelToBindings = (dtdlTargetModels, bindingDescription, dtdlSourceModels, draft) => {

  const { tb, pb, cb, telemetry, properties, commands } = mapBindingContents(dtdlTargetModels, bindingDescription);

  // const ttb = convertSourceToModel(tb, dtdlSourceModels);
  // const ppb = convertSourceToModel(pb, dtdlSourceModels);
  // const ccb = convertSourceToModel(cb, dtdlSourceModels);

  // const telemetryBindings = _.uniqBy([...tb, ...(draft ? createDefaultBindings(telemetry) : [])], 'contentId');
  // const propertyBindings = _.uniqBy([...pb, ...(draft ? createDefaultBindings(properties) : [])], 'contentId');
  // const commandBindings = _.uniqBy([...cb, ...(draft ? createDefaultBindings(commands) : [])], 'contentId');

  const ttb = convertSourceToModel(tb, dtdlSourceModels);
  const ppb = convertSourceToModel(pb, dtdlSourceModels);
  const ccb = convertSourceToModel(cb, dtdlSourceModels);

  const telemetryBindings = _.uniqBy([...ttb, ...(draft ? createDefaultBindings(telemetry) : [])], 'contentId');
  const propertyBindings = _.uniqBy([...ppb, ...(draft ? createDefaultBindings(properties) : [])], 'contentId');
  const commandBindings = _.uniqBy([...ccb, ...(draft ? createDefaultBindings(commands) : [])], 'contentId');

  return { telemetryBindings, propertyBindings, commandBindings };
};


export const convertSourceToModel = (contents, models) => {
  return _.map(contents, c => {
    // TODO _.map to make multiple sources possible
    const { modelId, name } = parseContentId(c.endpoints[0].contentId);
    const sourceModel = modelId ? _.find(models, { '@id': modelId }) : null;
    const source = name && sourceModel ? _.find(sourceModel?.contents, { name }) : null;
    return { ...c, sourceModel: sourceModel, source: source };
  });
};

export const createDefaultBindings = (contents) => {
  return _.map(contents, c => {
    const regexp = /.*:_c:(?<endpointId>.*);.*$/;
    const endpointId = c['@id'].match(regexp)?.groups.endpointId;
    return ({ contentId: c['@id'], displayName: c.displayName, endpointId });
  });
};

export const filterBindings = (modelContents, bindingContents) => {
  const b = _.filter(bindingContents, binding => {
    if (binding?.contentId) {
      const { name } = parseContentId(binding.contentId);
      return _.some(modelContents, c => c.name === name);
    }
    const { name } = parseContentId(binding.contentId);
    return _.some(modelContents, c => c.name === name);

  });
  return b;
};

filterBindings.propTypes = {
  modelContents: propTypes.arrayOf(Object).isRequired,
  bindingContents: propTypes.arrayOf(Object).isRequired
};

createDefaultBindings.propTypes = {
  contents: propTypes.arrayOf(Object).isRequired
};

mapModelToBindings.propTypes = {
  models: propTypes.arrayOf(Object).isRequired,
  bindingContents: propTypes.arrayOf(Object).isRequired
};
